<template>
  <div class="navbar-container d-flex content align-items-center" >

    <!-- Nav Menu Toggler -->
 


    <b-navbar-nav class="nav align-items-center ml-auto">
     <img src="@/assets/images/logo3.png" class="logo" alt="logo" />
    </b-navbar-nav>
  </div>
</template>

<script>
import {
  BLink, BNavbarNav, BNavItemDropdown, BDropdownItem, BDropdownDivider, BAvatar,
} from 'bootstrap-vue'
import DarkToggler from '@core/layouts/components/app-navbar/components/DarkToggler.vue'
import {Auth} from "@simb2s/senseye-sdk"
import CartDropdown from '@core/layouts/components/app-navbar/components/CartDropdown.vue'
export default {
  components: {
    BLink,
    BNavbarNav,
    BNavItemDropdown,
    BDropdownItem,
    BDropdownDivider,
    BAvatar,
    CartDropdown,
    // Navbar Components
    DarkToggler,
  },
  props: {
    toggleVerticalMenuActive: {
      type: Function,
      default: () => {},
    },
  },
  methods: {
    async logout()
    {
      await Auth.logout()
      document.location.reload(); 
    },
  }
}
</script>
<style scoped>
.logo
{
  height:20px;
}
</style>